import { useEffect, useState } from 'react';

/**
 * Tracks whether a CSS media query currently matches, updating on resize.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);

    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

// Matches Tailwind's stock `lg` breakpoint (1024px) - the same cutoff Header.tsx's hamburger
// button (`lg:hidden`) and the Sidebar's own desktop-rail behavior already use.
export function useIsMobileNav(): boolean {
  return !useMediaQuery('(min-width: 1024px)');
}
